import React from 'react'
import logo from '../images/logo_bw.png'
import linkedin from '../images/linkedin_black.png'
import {Link} from 'react-router-dom'
import insta from '../images/instagram.png'
const Footer = () => {
  return (
    <footer className="bg-[#D2D4DA]">
        <div className=" py-20 md:px-40 px-5">
            <div className="md:grid grid-cols-4 gap-8">
                <div className="mx-auto">
                <img src={logo} className="h-24 mx-auto"></img>
                <div className="flex space-x-3 mt-4 justify-center">
                <a href="https://www.linkedin.com/company/novelio-technologies/" target="_blank">
                <img src={linkedin} className="h-8"></img>
                </a> 
                <a href="https://www.instagram.com/interview.guru/" target="_blank"><img src={insta} className="h-8"></img></a>
                </div>
                </div>

                <div className="flex flex-col space-y-4 text-[#161A21]">
                    <Link to="/aboutus">
                    <p>About Us</p>
                    </Link>
                    <Link to="/howitworks">
                    <p>How it works</p>
                    </Link>
                    <Link to="/request">
                    <p>Request a demo</p>
                    </Link>
                    <Link to="/support">
                    <p>Support</p>
                    </Link>
                </div>

                <div className="flex flex-col space-y-4 text-[#161A21]">
                    <Link to="/privacy">
                    <p>Privacy Policy</p>
                    </Link>
                    <Link to="/terms">
                    <p>Terms & Conditions of Service</p>
                    </Link>
                   
                </div>
                <div className="flex flex-col space-y-4 text-[#161A21]">
                    <p>Contact Us:<br></br> Novelio Technologies Private Limited 7th Floor, Vatika Triangle, Mehrauli-Gurgaon Road, Block B, Sushant Lok Phase-1, Gurugram</p>
                    <p>Phone: <span className="text-[#148EFF]">+91 76204 56853</span></p>
                    <p>Email us at: <a href="mailto:info@interviewguru.co" className="text-[#148EFF]">info@interviewguru.co</a></p>
                    
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer